import { objectPick } from '@helpers/helpers';

export default {
    methods: {
        setExistingProperties: (obj1, obj2) => Object.assign(obj1, objectPick(obj2, Object.keys(obj1))),
        doLogout: () => {
            if (window.localStorage) {
                localStorage.setItem('event-logout', `logout-${Math.random()}`);
            }
        },
        updateScreenDimensions() {
            this.screenWidth = document.documentElement.clientWidth;
            this.isMobile = this.screenWidth < 760;
            this.isScreenLowerThanDesktop = this.screenWidth < 992;
        },
    },
};
